import { MAGNETIC_TOKENS } from '@appd/uik';
import { Threshold } from './models';

const {
  COLORS: { CONTROL_BG_MEDIUM_DISABLED, INFO_BG_MEDIUM, NEGATIVE_BG_MEDIUM, POSITIVE_BG_MEDIUM, WARNING_BG_MEDIUM },
} = MAGNETIC_TOKENS;

const { COLORS } = MAGNETIC_TOKENS;

export const DEFAULT_THRESHOLDS: Threshold[] = [
  {
    name: 'Normal',
    condition: 'function($value){ $value > 0 and $value < 33 }',
    color: COLORS.POSITIVE_BG,
  },
  {
    name: 'Warning',
    condition: 'function($value){ $value >= 33 and $value < 66 }',
    color: COLORS.WARNING_BG,
  },
  {
    name: 'Critical',
    condition: 'function($value){ $value > 66 }',
    color: COLORS.SEVERE_WARNING_BG,
  },
];

export const THRESHOLD_IDENTIFIER_JSONATA_EXPRESSION =
  '$filter($.thresholds, function($threshold){ ($checkCondition := $eval($threshold.condition); $checkCondition($.value)) })';

export const TAG_CELL_RENDERER_DEFAULT_THRESHOLDS = [
  {
    name: 'ACTIVE',
    icon: 'Health.Active',
    color: INFO_BG_MEDIUM,
    backgroundColor: POSITIVE_BG_MEDIUM,
    condition: 'function($value){ $value >= 90 and $value <= 100 }',
  },
  {
    name: 'POSITIVE',
    icon: 'Health.Normal',
    color: POSITIVE_BG_MEDIUM,
    backgroundColor: POSITIVE_BG_MEDIUM,
    condition: 'function($value){ $value >= 70 and $value < 90 }',
  },
  {
    name: 'INFO',
    icon: 'Health.InfoMessage',
    color: INFO_BG_MEDIUM,
    backgroundColor: INFO_BG_MEDIUM,
    condition: 'function($value){ $value >= 50 and $value < 70 }',
  },
  {
    name: 'WARNING',
    icon: 'Health.Warning',
    color: WARNING_BG_MEDIUM,
    backgroundColor: WARNING_BG_MEDIUM,
    condition: 'function($value){ $value >= 30 and $value < 50 }',
  },
  {
    name: 'INACTIVE',
    icon: 'Health.Inactive',
    color: CONTROL_BG_MEDIUM_DISABLED,
    backgroundColor: CONTROL_BG_MEDIUM_DISABLED,
    condition: 'function($value){ $value >= 10 and $value < 30 }',
  },
  {
    name: 'NEGATIVE',
    icon: 'Health.Critical',
    color: NEGATIVE_BG_MEDIUM,
    backgroundColor: NEGATIVE_BG_MEDIUM,
    condition: 'function($value){ $value >= 1 and $value < 10 }',
  },
  {
    name: 'DISABLED',
    icon: 'Health.Terminated',
    color: CONTROL_BG_MEDIUM_DISABLED,
    backgroundColor: CONTROL_BG_MEDIUM_DISABLED,
    condition: 'function($value){ $value >= 0 and $value < 1 }',
  },
];
